import { Component, effect, inject } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import {
  PrestationModalContent,
  PrestationModalService,
} from '../../services/prestation-modal.service';
import { PrestationTypeSelectorComponent } from './prestation-type-selector/prestation-type-selector.component';
import { TransportModalComponent } from './transport-modal/transport-modal.component';
import { MealModalComponent } from './meal-modal/meal-modal.component';
import { AccommodationModalComponent } from './accommodation-modal/accommodation-modal.component';
import { TransportFormService } from '../../services/transport-form.service';
import { ActivityModalComponent } from './activity-modal/activity-modal.component';

@Component({
  selector: 'app-prestation-modal',
  imports: [
    Dialog,
    PrestationTypeSelectorComponent,
    TransportModalComponent,
    AccommodationModalComponent,
    ActivityModalComponent,
    MealModalComponent,
  ],
  templateUrl: './prestation-modal.component.html',
})
export class PrestationModalComponent {
  prestationModalService = inject(PrestationModalService);
  transportFormService = inject(TransportFormService);

  visible = false;

  constructor() {
    effect(() => {
      this.visible = this.prestationModalService.showModal();
    });
  }
  closeModal() {
    this.visible = false;
    this.prestationModalService.showModal.set(false);
    if (this.displayAddTransport) {
      this.transportFormService.resetFormGroup();
    }
  }

  get displaySelectPrestation() {
    return (
      this.prestationModalService.modalContent() ===
      PrestationModalContent.SelectPrestation
    );
  }

  get displayAddTransport() {
    return (
      this.prestationModalService.modalContent() ===
      PrestationModalContent.AddTransport
    );
  }
  get displayAddAccommodation() {
    return (
      this.prestationModalService.modalContent() ===
      PrestationModalContent.AddAccommodation
    );
  }
  get displayAddActivity() {
    return (
      this.prestationModalService.modalContent() ===
      PrestationModalContent.AddActivity
    );
  }
  get displayAddMeal() {
    return (
      this.prestationModalService.modalContent() ===
      PrestationModalContent.AddMeal
    );
  }
}
